import { createReducer } from "sc/helpers/reducer";
import { REGIONS_LOADED } from "../actions/regions";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [REGIONS_LOADED]: (state, action) => action.payload.regions,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/regions-reducer.js